export default "__VITE_ASSET__D3S9O2X5__";